import React from 'react';
import PropTypes from 'prop-types';
import CarinaModal from '@cvent/carina/components/Modal';
import ScrollViewWithBars from '@cvent/carina/components/ScrollViewWithBars/ScrollViewWithBars';
import { injectTestId } from '@cvent/nucleus-test-automation';

const useStyles = () => {
  return {
    title: {
      margin: 24,
      marginBottom: 16
    },
    content: {
      marginRight: 24,
      marginLeft: 24,
      whiteSpace: 'pre-wrap'
    },
    footer: {
      margin: 24,
      marginTop: 16
    }
  };
};

const FullscreenModal = ({
  header,
  content,
  footer,
  testID,
  ariaLabel,
  disableFocusTrap
}) => {
  const styles = useStyles();

  return (
    <main role="main">
      <div {...injectTestId('FullscreenModal')}>
        <CarinaModal
          isOpen
          format="l"
          testID={testID}
          scrollLock={false}
          disableFocusTrap={disableFocusTrap}
          aria-label={ariaLabel || undefined}
        >
          <ScrollViewWithBars
            header={<h1 css={styles.title}>{header}</h1>}
            footer={<div css={styles.footer}>{footer}</div>}
          >
            <div css={styles.content}>{content}</div>
          </ScrollViewWithBars>
        </CarinaModal>
      </div>
    </main>
  );
};

FullscreenModal.propTypes = {
  header: PropTypes.node,
  content: PropTypes.node,
  footer: PropTypes.node,
  testID: PropTypes.string,
  ariaLabel: PropTypes.string,
  disableFocusTrap: PropTypes.bool
};

export default FullscreenModal;
